export default __webpack_public_path__ + "static/media/Pending.eb05b97c.svg";